import { Directive, ElementRef, inject, input, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AclRoles, AclService } from '../../..';

/**
 * Disabilita un elemento se l'utente non è admin.
 * Funziona su:
 *  - FormControl (reactive forms): chiama control.disable() / control.enable()
 *  - Elementi nativi (button, input, select, a, ...): setta/rimuove l'attributo [disabled]
 *
 * Pronta per ACL: in futuro basterà sostituire la lettura di `authService.isAdminUser`
 * con una chiamata al servizio ACL passando il permesso ricevuto in input.
 *
 */
@Directive({
  selector: '[h5sHasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit {
  private readonly aclService = inject(AclService);

  // Structural
  private readonly templateRef = inject(TemplateRef<unknown>, { optional: true });
  private readonly viewContainerRef = inject(ViewContainerRef, { optional: true });

  // Attribute
  private readonly ngControl = inject(NgControl, { optional: true, self: true });
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  readonly roles = input<AclRoles | AclRoles[]>(AclRoles.Admin);

  ngOnInit(): void {
    const hasPermission = this.aclService.hasRole(this.roles());

    if (this.templateRef && this.viewContainerRef) {
      // Modalità strutturale — show/hide
      this.viewContainerRef.clear();
      if (hasPermission) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else if (this.ngControl?.control) {
      // Modalità attribute su FormControl
      hasPermission
        ? this.ngControl.control.enable({ emitEvent: false })
        : this.ngControl.control.disable({ emitEvent: false });
    } else {
      // Modalità attribute su elemento nativo
      this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', !hasPermission);
    }
  }
}
